import React, {useState, useEffect} from "react";
import {Card, Container, Row, Col, CardGroup, 
        CardBody,Alert, 
        Nav,NavItem,NavLink,
        TabContent, TabPane,
} from 'reactstrap';
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker,
    InfoWindow, 
    Polyline
} from "react-google-maps"
import logoAutoma from '../../../assets/img/brand/automa-logo-black.png'
import classnames from "classnames";
// import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import { fetchTnTList } from '../../../redux/actions/aTransporter-TrackAndTrace';
import { connect } from "react-redux";
import { HashLoader } from 'react-spinners';
import VerticalTimeline from './VerticalTimeline';
import Steps from './VerticalTimeline/Steps';
import { compose } from "recompose"
import customMarkerMoving from '../../../assets/img/truck.png'
import customMarker from '../../../assets/img/pin.png'
import departureMarkerPin from '../../../assets/img/departure-pin.png'
import decodePolyline from 'decode-google-map-polyline'
import {Redirect} from 'react-router';

const MapWithAMarker = compose(
    withScriptjs, 
    withGoogleMap,
    )(props => {
        const dcPoly = props.mapOptimized ? decodePolyline(props.mapOptimized) : []
        const destinationMarkerPin = (destNumber) => {
            const markerSvg = `<svg width="32px" height="32px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="si-glyph si-glyph-flag">
                        <title>96</title>
                        <defs>
                        </defs>
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g transform="translate(1.000000, 0.000000)" fill="#434343">
        
                            <rect x="0" y="0" width="1.99365234" height="15.913" class="si-glyph-fill" fill="#7f8fa6" ></rect>
                            <path d="M3.056,0.52 L3.056,8.095 C3.056,8.095 4.667,6.664 8.244,8 C11.82,9.338 12.549,8.974 13.956,8.742 C13.956,8.742 
                                    11.908,7.871 10.734,4.713 C10.734,4.713 13.721,1.958 13.956,0.439 C13.956,0.439 10.256,1.651 8.205,0.68 C6.152,-0.293 3.994,-0.089 3.056,0.52 L3.056,0.52 Z" class="si-glyph-fill" fill="#1e90ff"></path>
                            <text x="6" y="6" font-family="Arial" font-weight="bold" font-size="5" fill="white">${destNumber}</text>
                        </g>
                        </g>
            </svg>`

            const buff = new Buffer.from(markerSvg);
            const base64data = buff.toString('base64');
            return 'data:image/svg+xml;base64,'+base64data
        }
        
        return (
        <GoogleMap defaultZoom={9} defaultCenter={{ lat:  ( !props.companyLat ? -7.6221790314:  props.companyLat), lng: ( !props.companyLng ? 110.8043441772:  props.companyLng) }}>

            <Marker
                options={{icon: customMarkerMoving}}
                position={{ lat: props.fleetStatus.lat, lng: props.fleetStatus.lon }}
            >
            </Marker>    
            
            <Polyline
                path={props.markers}
                geodesic={true}
                options={{
                    strokeColor: "#3bba3c",
                    strokeOpacity: 0.90,
                    strokeWeight: 5,
                    icons: [
                        {
                            // icon: lineSymbol,
                            offset: "0",
                            repeat: "20px"
                        }
                    ]
                }}
            />
            <Polyline
                path={dcPoly}
                geodesic={true}
                options={{
                    strokeColor: "#3A5FCD",
                    strokeOpacity: 0.90,
                    strokeWeight: 5,
                    icons: [
                        {
                            // icon: lineSymbol,
                            offset: "0",
                            repeat: "20px"
                        }
                    ]
                }}
            />
            {/* <MapDirectionsRenderer
                waypoints={props.waypoints}
                avoidToll={props.doDetails[0].avoid_toll > 0 ? true : false}
                travelMode={window.google.maps.TravelMode.DRIVING}
            /> */}
        

        {/* WO Markers */}
        {props.nextDestMarker.map((marker, i) => {
          
          const onClick = props.onClick.bind(this, marker)
            return (
                <Marker
                  key={marker.id}
                  onClick={onClick}
                    options={{icon: customMarker}}
                  position={{ lat: marker.lat, lng: marker.lng }}
                >
                    {props.selectedMarker === marker &&
                  <InfoWindow>
                    <div>
                      {marker.sp_name}
                    </div>
                  </InfoWindow>
                }
                </Marker>
            )
        })}
        {props.woMarker.map((marker, i) => {
          
          const onClick = props.onClick.bind(this, marker)
            return (
                <Marker
                  key={marker.work_order_from.id}
                  onClick={onClick}
                    options={{icon: i === 0? departureMarkerPin : destinationMarkerPin(i)}}
                  position={{ lat: marker.work_order_from.lat, lng: marker.work_order_from.lng }}
                >
                    {props.selectedMarker === marker &&
                  <InfoWindow>
                    <div>
                      {marker.work_order_from.wo_destination_name}<br/>{marker.work_order_from.wo_number}
                    </div>
                  </InfoWindow>
                }
                </Marker>
            )
        })}
      </GoogleMap>
    )
})

const Timeline = ({data, current, shipper}) => {
    return(
        <div>
        <dd style={{"display":"flex","margin-top":"10px"}}>
            <VerticalTimeline data={data} current={current}/>
            <Steps data={data} current={current} shipper={shipper}/>
        </dd>
    </div>
    )
}

// const UpNext = ({data}) => {
//     var options = {
//         noDataText: 'No data registered',
//         sizePerPage: 10,
//         // btnGroup: this.customBtnGroup,
//     };
//     return (
//         <React.Fragment>
//             <BootstrapTable data={data? data : []} version="4" striped 
//             edit options={options} exportCSV={false} 
//             csvFileName={this.fileNameFormat} multiColumnSearch>
//         <TableHeaderColumn dataField="id" isKey  csvHeader="ID" searchable={false} hidden></TableHeaderColumn>
//         <TableHeaderColumn dataField="company" searchable  csvHeader="Company" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="15%" >Comp</TableHeaderColumn>
//         <TableHeaderColumn dataField="do_number"   csvHeader="DO Number" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%"  >DO</TableHeaderColumn>
//         <TableHeaderColumn dataField="seq"   csvHeader="Seq" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="10%"  >Seq</TableHeaderColumn>
//         <TableHeaderColumn dataField="do_desc"     csvHeader="DO Desc" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%">Desc</TableHeaderColumn>
//         <TableHeaderColumn dataField="fleet_plate"    searchable  csvHeader="Fleet Plate" thStyle={ { whiteSpace: 'normal' } } width="20%">Fleet</TableHeaderColumn>
//         <TableHeaderColumn dataField="driver_name" tdStyle={ { whiteSpace: 'normal' } }  searchable  csvHeader="Driver Name" thStyle={ { whiteSpace: 'normal' } } width="15%">Driver</TableHeaderColumn>
//         <TableHeaderColumn dataField="driver_assistant_name" tdStyle={ { whiteSpace: 'normal' } } csvHeader="Driver Assistant Name" thStyle={ { whiteSpace: 'normal' } }  width="15%" hidden>Asst.</TableHeaderColumn>
//         <TableHeaderColumn dataField="assigned_do_date"    csvHeader="DO Start Date" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="15%">Start</TableHeaderColumn>
//         <TableHeaderColumn dataField="end_assigned_do_date"    csvHeader="DO End Date" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="15%">End</TableHeaderColumn>
//         {/* <TableHeaderColumn dataField="created_on"  csvHeader="DO Issued On"   thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="15%">DO Issued On</TableHeaderColumn> */}
//         </BootstrapTable>
//     </React.Fragment>
//     )
// }

// const Finished = ({data}) => {
//     var options = {
//         noDataText: 'No data registered',
//         sizePerPage: 10,
//         // btnGroup: this.customBtnGroup,
//     };
//     return (
//         <React.Fragment> 
//             <BootstrapTable  data={data? data : []} version="4" striped 
//             edit options={options} exportCSV={false} 
//             csvFileName={this.fileNameFormat} multiColumnSearch>
//         <TableHeaderColumn dataField="id" isKey  csvHeader="ID" searchable={false} hidden></TableHeaderColumn>
//         <TableHeaderColumn dataField="company" searchable  csvHeader="Company" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="15%" >Comp</TableHeaderColumn>
//         <TableHeaderColumn dataField="do_number"   csvHeader="DO Number" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%"  >DO</TableHeaderColumn>
//         <TableHeaderColumn dataField="seq"   csvHeader="Seq" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="10%"  >Seq</TableHeaderColumn>
//         <TableHeaderColumn dataField="do_desc"     csvHeader="DO Desc" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%">Desc</TableHeaderColumn>
//         <TableHeaderColumn dataField="fleet_plate"    searchable  csvHeader="Fleet Plate" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%">Fleet</TableHeaderColumn>
//         <TableHeaderColumn dataField="driver_name"   searchable  csvHeader="Driver Name" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="15%">Driver</TableHeaderColumn>
//         <TableHeaderColumn dataField="driver_assistant_name"  csvHeader="Driver Assistant Name" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="15%" hidden>Asst.</TableHeaderColumn>
//         <TableHeaderColumn dataField="assigned_do_date"    csvHeader="DO Start Date" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="15%">Start</TableHeaderColumn>
//         <TableHeaderColumn dataField="end_assigned_do_date"    csvHeader="DO End Date" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="15%">End</TableHeaderColumn>
//         {/* <TableHeaderColumn dataField="created_on"  csvHeader="DO Issued On"   thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="15%">DO Issued On</TableHeaderColumn> */}
//         </BootstrapTable>
//     </React.Fragment>
//     )
// }

const TrackAndTraceTracker = ({fetchTnTList, trackAndTraceListData, trackAndTraceLoading, ...props}) => {

    const [selectedMarker, setSelectedMarker] = useState(null)

    useEffect(() => {
        fetchTnTList("", props.match.params.id)
    },[])

    const handleClick = (marker, event) => {
        setSelectedMarker(marker)
    }

    console.log(trackAndTraceListData)

    return(
        <div className="app flex-row align-items-center login-body"> 
            <Container>
            <Row className="justify-content-center">
                <Col md="9">
                <CardGroup>
                    <Card className="p-4">
                    <CardBody>
                        {trackAndTraceLoading === "loading" &&
                            <center>
                                <HashLoader color={'#123abc'} loading={true}/>
                                    <br /> Loading.... Please wait...
                            </center>
                        }
                        {trackAndTraceLoading === "success" ?
                            trackAndTraceListData.currentDoDetail.fleet_status?
                                <React.Fragment>
                                    <img src={logoAutoma} alt="Automa Logo" className="automa-logo-login" style={{'maxWidth': '2em', 'height': 'auto'}}/>
                                    <br/><br/>
                                    <h4>Automa Transporter Tracker ({props.match.params.bucket})</h4><br/>
                                    <Card>
                                        <Alert color="success" style={{ marginBottom: 0 }}>
                                            Current <b>{trackAndTraceListData.current.do_number}</b> in delivery
                                        </Alert>
                                        <MapWithAMarker
                                            selectedMarker={selectedMarker}
                                            markers={trackAndTraceListData.currentDoDetail.fleetPath}
                                            nextDestMarker={trackAndTraceListData.otherThanCurrentWo}
                                            onClick={handleClick}
                                            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCmIATqobqbCEU90nYtwd-PzCcj8EVOlDg&v=3.exp&libraries=geometry,drawing,places"
                                            loadingElement={<div style={{ height: `100%` }} />}
                                            containerElement={<div style={{ height: `600px` }} />}
                                            mapElement={<div style={{ height: `100%` }} />}
                                            woMarker={trackAndTraceListData.currentDoDetail.checkin}
                                            doDetails={trackAndTraceListData.current}
                                            mapOptimized={trackAndTraceListData.current.overview_polyline}
                                            fleetStatus={trackAndTraceListData.currentDoDetail.fleet_status}
                                            mapOptions={ {
                                                showFleetSteps: false,
                                            }}
                                        />
                                        <Alert color="primary">
                                        <Row>
                                            <Col md="6">
                                            <dt>Driver Name</dt>
                                            <dd>
                                                {trackAndTraceListData.current.driver_name}
                                            </dd>
                                            <dt>Driver Assistant Name</dt>
                                            <dd>
                                                {trackAndTraceListData.current.driver_assistant_name}
                                            </dd>
                                            </Col>
                                            <Col md="6">
                                            <dt>Transporter</dt>
                                            <dd>
                                                {trackAndTraceListData.current.company}
                                            </dd>
                                            <dt>Shipper</dt>
                                            <dd>
                                                {props.match.params.company}
                                            </dd>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="6">
                                            <dt>Fleet Id</dt>
                                            <dd>
                                                {trackAndTraceListData.current.fleet_plate}
                                            </dd>
                                            </Col>
                                        </Row>
                                        </Alert>
                                        <Tabs tabContent={[
                                                {
                                                    dataTab: "timeline",
                                                    tabName: "Timeline",
                                                    tabIcon: "",
                                                    component: (
                                                        <Timeline 
                                                            data={trackAndTraceListData.timeline}
                                                            shipper={props.match.params.company}
                                                            current={trackAndTraceListData.current}
                                                        />
                                                    ),
                                                },
                                                // {
                                                //     dataTab: "up-next",
                                                //     tabName: "Up Next",
                                                //     tabIcon: "",
                                                //     component: (
                                                //         <UpNext data={trackAndTraceListData.upNext}/>
                                                //     ),
                                                // },
                                                // {
                                                //     dataTab: "finished",
                                                //     tabName: "Finished",
                                                //     tabIcon: "",
                                                //     component: (
                                                //         <Finished data={trackAndTraceListData.history}/>
                                                //     ),
                                                // },
                                        ]}/>
                                    </Card>
                                </React.Fragment>
                                :
                                <Redirect to="/" />
                            : null
                    }
                    </CardBody>
                </Card>
                    </CardGroup>
                    </Col>
            </Row>
            </Container>
        </div>

    )

}

const Tabs = ({ tabContent }) => {
    const [activeTab, onActiveTabChange] = useState(tabContent[0].dataTab);
    return (
        <React.Fragment>
        <Row style={{marginTop:"-16px"}}>
            <Col xs="12" md="12" className="mb-4">
            <Nav tabs>
                {tabContent.map((content, index) => (
                <NavItem key={index + 1}>
                    <NavLink
                    className={classnames({
                        active: activeTab === content.dataTab,
                    })}
                    onClick={() => {
                        onActiveTabChange(content.dataTab);
                    }}
                    >
                    <i className={content.tabIcon}></i>&nbsp;
                    {content.tabName}
                    </NavLink>
                </NavItem>
                ))}
            </Nav>
            <TabContent activeTab={activeTab} style={{marginBottom:"-25px"}}>
                {tabContent.map((content, index) => (
                <TabPane tabId={content.dataTab} key={index + 1}>
                    {content.component}
                </TabPane>
                ))}
            </TabContent>
            </Col>
        </Row>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    return {
        trackAndTraceListData: state.trackAndTraceStore.trackAndTraceListData,
        trackAndTraceLoading: state.trackAndTraceStore.loading,
    }
}
const mapDispatchToProps = {fetchTnTList};
export default connect(mapStateToProps, mapDispatchToProps)(TrackAndTraceTracker);



// WEBPACK FOOTER //
// ./src/views/Transporter/TrackAndTraceTracker/index.jsx